import classNames from "classnames";
import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import { SwiperSlide } from "swiper/react";
import { useMultimediaArticles } from "../../../services/apiHooks/multimedia";
import Section from "./Section";
import { MultimediaTypesFilter } from "../Multimedia/TypeFilter";
import { useLinks } from "../../../services/helpers/links";
import { Loader } from "../../common";
import { ArticleCardWrapper } from "../../common/Article/ArticleCardWrapper";
import { CarouselWrapper } from "./CarouselWrapper";

export const MultimediaSectionCarousel = ({ background, className = {} }) => {
  const { t } = useTranslation(["cft", "multimedia"]);
  const [activeType, setActiveType] = useState(null);
  const { multimedia, isLoading } = useMultimediaArticles({
    typeFilter: activeType,
  });
  const { multimedias: multimediasLink } = useLinks();

  const allCategoriesLinkAnchor = t("multimedia:link-all");
  const swiper = useRef(null);

  return (
    <div className={`Sections--${background}`}>
      <Container>
        <Section
          className={classNames({
            className,
            "has-categories": true,
          })}
          title={<h2>{t("multimedia:title")}</h2>}
        >
          <>
            <div className="Sections__categories has-categories">
              <MultimediaTypesFilter
                activeType={activeType}
                setActiveType={setActiveType}
              />
              <Link to={multimediasLink()} className="Sections__more">
                {allCategoriesLinkAnchor}
              </Link>
            </div>
            {isLoading ? (
              <Loader small />
            ) : (
              <CarouselWrapper swiperRef={swiper}>
                {multimedia &&
                  multimedia.map(el => {
                    return (
                      <SwiperSlide
                        key={`multi-art-${el.slug}`}
                        style={{ height: "auto" }}
                      >
                        <ArticleCardWrapper
                          key={el.slug}
                          id={el.id}
                          isMultimedia
                          article={el}
                        />
                      </SwiperSlide>
                    );
                  })}
              </CarouselWrapper>
            )}
          </>
        </Section>
      </Container>
    </div>
  );
};
